<template>
  <div>
    <header>
      <van-row>
        <van-col span="22" >
          <div style="float: left; margin-top: 0.7rem;" @click.stop="ToHome">
            <van-image :src="logoUrl" style="width: 2.1rem;" round />
          </div>
          <div class="logo_text" style="margin-left: 2.5rem; margin-top: 0.7rem;">
            <h2 style="color: #555555; font-size: 0.9rem; margin: 0;">义乌市伊拉文进出口有限公司</h2>
            <span style="color: #999999; font-size: 0.6rem;">纺织、服装及家庭用品批发</span>
          </div>
        </van-col>
        <van-col span="2" style="margin-top: 0.8rem;">
          <van-icon name="bars" size="34" @click="toggleSideBar" />
        </van-col>
      </van-row>
    </header>
    <van-popup :value="menuShow" position="left" closeable :style="{ height: '100%', width: '100%' }" @click-close-icon="toggleSideBar">
      <van-cell @click="ToHome()">{{ $t('home') }}</van-cell>
      <van-cell @click="ToPage('/about')" is-link>关于我们</van-cell>
      <van-cell @click="ToPage('/staffs')" is-link>员工一览</van-cell>
      <van-cell @click="ToPage('/news')" is-link>新闻资讯</van-cell>
      <van-cell @click="ToPage('/contact')" is-link>联系我们</van-cell>
<!--      <van-cell to="/products" is-link>{{ $t('appproducts') }}</van-cell>-->
<!--      <van-cell>-->
<!--        <van-radio-group :value="$store.state.app.lang">-->
<!--          <van-radio name="zh" shape="square" @click="LangChange('zh')">中文</van-radio>-->
<!--          <van-radio name="en" shape="square" @click="LangChange('en')">English</van-radio>-->
<!--        </van-radio-group>-->
<!--      </van-cell>-->
    </van-popup>
  </div>
</template>

<script>
  import {Button, Cell, CellGroup, NavBar, Icon, Popup, RadioGroup, Radio, Row, Col, Image} from "vant";
  export default {
    name: 'MyHeader',
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Popup.name]: Popup,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Row.name]: Row,
      [Col.name]: Col,
      [Image.name]: Image,
      [Button.name]: Button
    },
    data () {
      return {
        lang: '',
        logoUrl: require('../../assets/img/logo.png'),
      }
    },
    computed: {
      menuShow() {
        return this.$store.state.app.headerMenuShow
      }
    },
    props: {
    },
    watch:{
    },
    methods: {
      LangChange(lang) {
        this.$store.dispatch('app/setLang', lang).then(res => {
          this.$i18n.locale = lang
        })
      },
      toggleSideBar() {
        this.$store.dispatch('app/toggleHeaderMenuShow')
      },
      colseHeaderMenuShow() {
        this.$store.dispatch('app/colseHeaderMenuShow')
      },
      ToHome() {
        // this.menuShow = false
        this.colseHeaderMenuShow()
        this.$router.push({path: '/'})
      },
      ToPage(path) {
        // this.menuShow = false
        this.colseHeaderMenuShow()
        this.$router.push({path: path})
      }
    },
    mounted() {
      console.log()

      // console.log(this.$store.state.app)
    }
  }
</script>

<style scoped>
  header{
    height: 3.6rem;
    padding: 0 0.9rem;
    border-bottom: 1px solid #e9e9e9;
  }
</style>
